import { IAdminInquiriesTableData, IAdminSearchInquiriesPayload } from '@interfaces/adminInquiries';

import { apiUrls } from './urls';
import { post } from './utils';

export const adminSearchInquiries = (payload: IAdminSearchInquiriesPayload) =>
  post<IAdminInquiriesTableData>(apiUrls.adminInquiries.searchInquiriesDivided, payload);

export const adminInquirySendResponse = (inquiryId: number) =>
  post(apiUrls.adminInquiries.sendResponse, { inquiryId });
